const LEADING_POSTAL_CODE_REGEX = /^(?:[A-Z]{1,3}-)?\d{2,5}(?:-\d{2,5})?\s+/i;

export function normalizeCityName(value?: string | null): string {
  if (!value) return '';

  return value
    .trim()
    .replace(LEADING_POSTAL_CODE_REGEX, '')
    .replace(/\s+/g, ' ')
    .trim();
}

export function slugifyCity(value?: string | null): string {
  return normalizeCityName(value)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/ß/g, 'ss')
    .replace(/æ/gi, 'ae')
    .replace(/œ/gi, 'oe')
    .replace(/ø/gi, 'o')
    .replace(/đ/gi, 'd')
    .replace(/ł/gi, 'l')
    .replace(/[^a-zA-Z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .toLowerCase();
}

export function getNormalizedCityKey(city?: string | null, country?: string | null, citySlug?: string | null): string {
  const normalizedSlug = slugifyCity(citySlug || city);
  return `${(country || '').toUpperCase()}::${normalizedSlug}`;
}
